import { useSelector } from "react-redux";

export const useContactFormOptions = () => useSelector((state) => state.contactsReducer.formOptions);
export const useContactPerson = () => useSelector((state) => state.contactsReducer.person);
export const useShowPhoneContext = () => useSelector((state) => state.contactsReducer.showPhoneContext);
